module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item__infos"
  }, [_c('a', {
    staticClass: "item__infos__main",
    attrs: {
      "target": "_blank",
      "href": _vm.project.link
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.project.title))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.project.client))])]), _vm._v(" "), _c('div', {
    staticClass: "item__infos__sub"
  }, [_c('div', [_c('h3', [_vm._v("[type]")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.project.type))])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("[role]")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.project.role))])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("[stack]")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.project.stack))])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("[" + _vm._s(_vm.project.more[0]) + "]")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.project.more[1]))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-72299e7e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slider/SliderItemInfos.vue
// module id = 90
// module chunks = 2